import React, { useState, useCallback } from "react";
import {
  Form,
  Input,
  Tooltip,
  Cascader,
  Select,
  Row,
  Col,
  Checkbox,
  Button,
  AutoComplete,
} from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { withRouter } from "react-router-dom";
import app from "../base";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

const RegistrationForm = ({ history }) => {
  const [form] = Form.useForm();
  const handleSignUp = useCallback(
    async (event) => {
      event.preventDefault();
      const { email, password } = event.target.elements;
      try {
        await app
          .auth()
          .createUserWithEmailAndPassword(email.value, password.value);
        history.push("/dashboard");
      } catch (error) {
        alert(error);
      }
    },
    [history]
  );
  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const [autoCompleteResult, setAutoCompleteResult] = useState([]);

  return (
    <div>
      <Form>
        <h3>Sign Up</h3>
        <form onSubmit={handleSignUp}>
          <label>
            Email
            <input name="email" type="email" placeholder="Email" />
          </label>
          <br/>
          <label>
            Password
            <input name="password" type="password" placeholder="Password" />
          </label>
          <button type="submit">Sign Up</button>
        </form>
      </Form>
    </div>
    // <Form
    //   {...formItemLayout}
    //   form={form}
    //   name="register"
    //   onFinish={handleSignup}
    //   initialValues={{
    //     residence: ["zhejiang", "hangzhou", "xihu"],
    //     prefix: "86",
    //   }}
    //   scrollToFirstError
    // >
    //   <Form.Item
    //     name="nickname"
    //     label={<span>Nama</span>}
    //     rules={[
    //       {
    //         required: true,
    //         message: "Please input your nickname!",
    //         whitespace: true,
    //       },
    //     ]}
    //   >
    //     <Input />
    //   </Form.Item>

    //   <Form.Item
    //     name="email"
    //     label="E-mail"
    //     rules={[
    //       {
    //         type: "email",
    //         message: "The input is not valid E-mail!",
    //       },
    //       {
    //         required: true,
    //         message: "Please input your E-mail!",
    //       },
    //     ]}
    //   >
    //     <Input />
    //   </Form.Item>

    //   <Form.Item
    //     name="password"
    //     label="Password"
    //     rules={[
    //       {
    //         required: true,
    //         message: "Please input your password!",
    //       },
    //     ]}
    //     hasFeedback
    //   >
    //     <Input.Password />
    //   </Form.Item>

    //   <Form.Item
    //     name="confirm"
    //     label="Confirm Password"
    //     dependencies={["password"]}
    //     hasFeedback
    //     rules={[
    //       {
    //         required: true,
    //         message: "Please confirm your password!",
    //       },
    //       ({ getFieldValue }) => ({
    //         validator(rule, value) {
    //           if (!value || getFieldValue("password") === value) {
    //             return Promise.resolve();
    //           }
    //           return Promise.reject(
    //             "The two passwords that you entered do not match!"
    //           );
    //         },
    //       }),
    //     ]}
    //   >
    //     <Input.Password />
    //   </Form.Item>

    //   <Form.Item
    //     name="agreement"
    //     valuePropName="checked"
    //     rules={[
    //       {
    //         validator: (_, value) =>
    //           value
    //             ? Promise.resolve()
    //             : Promise.reject("Should accept agreement"),
    //       },
    //     ]}
    //     {...tailFormItemLayout}
    //   >
    //     <Checkbox>
    //       I have read the <a href="">agreement</a>
    //     </Checkbox>
    //   </Form.Item>
    //   <Form.Item {...tailFormItemLayout}>
    //     <Button type="primary" htmlType="submit">
    //       Register
    //     </Button>
    //   </Form.Item>
    // </Form>
  );
};

export default withRouter(RegistrationForm);
